// Central bilingual content for Gruppo CB (IT / EN)
import {
    Droplets,
    Flame,
    Snowflake,
    Sun,
    ShieldCheck,
    Wrench,
} from "lucide-react";

export const CONTACT = {
    company: "Gruppo CB srl",
    address: "Via dei Contadini, 48 — 06132 San Martino in Colle (PG)",
    phone: "075 9979639",
    mobile: "348 4607897",
    whatsapp: "393484607897",
    emails: [
        "segreteria@gruppocb.net",
        "info@gruppocb.net",
        "amministrazione@gruppocb.net",
        "ufficiotecnico@gruppocb.net",
    ],
    mapsEmbed:
        "https://www.google.com/maps?q=Via+dei+Contadini+48,+06132+San+Martino+in+Colle+PG&output=embed",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1772299121503-cd62a57e3a26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxlbmdpbmVlcnMlMjB3b3JraW5nJTIwbW9kZXJuJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzg0MjMzNzM0fDA&ixlib=rb-4.1.0&q=85",
    about: "https://images.unsplash.com/photo-1781330173674-c7e809277fbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxlbmdpbmVlcnMlMjB3b3JraW5nJTIwbW9kZXJuJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzg0MjMzNzM0fDA&ixlib=rb-4.1.0&q=85",
    hvac: "https://images.unsplash.com/photo-1542274368-443d694d79aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwcGlwZXMlMjBodmFjfGVufDB8fHx8MTc4NDIzMzczNHww&ixlib=rb-4.1.0&q=85",
    solar: "https://images.unsplash.com/photo-1775317776711-ef4a57017181?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMGluZHVzdHJpYWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg0MjMzNzM0fDA&ixlib=rb-4.1.0&q=85",
    fire: "https://images.unsplash.com/photo-1613929906260-c9377d135547?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxyZWQlMjBpbmR1c3RyaWFsJTIwZmlyZSUyMHByb3RlY3Rpb24lMjBwaXBlc3xlbnwwfHx8fDE3ODQyMzM3MzR8MA&ixlib=rb-4.1.0&q=85",
    cta: "https://images.unsplash.com/photo-1768224123432-729e0a6fed58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVscyUyMGluZHVzdHJpYWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg0MjMzNzM0fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
    {
        slug: "idraulici",
        icon: Droplets,
        image: "/projects/bathroom.jpg?v=2",
        it: {
            name: "Impianti Idraulici",
            short: "Impianti idrico-sanitari e reti di distribuzione per ogni esigenza.",
            desc: "Progettazione e installazione di impianti idrico-sanitari civili e industriali, reti di adduzione e scarico, sistemi di trattamento e distribuzione dell'acqua realizzati a regola d'arte.",
            benefits: [
                "Materiali certificati e duraturi",
                "Efficienza idrica e riduzione degli sprechi",
                "Soluzioni su misura per privati, condomini e industrie",
                "Manutenzione programmata",
            ],
        },
        en: {
            name: "Plumbing Systems",
            short: "Water and sanitary systems and distribution networks for any need.",
            desc: "Design and installation of civil and industrial plumbing systems, supply and drainage networks, water treatment and distribution systems built to the highest standards.",
            benefits: [
                "Certified, durable materials",
                "Water efficiency and waste reduction",
                "Tailored solutions for homes, condos and industry",
                "Scheduled maintenance",
            ],
        },
    },
    {
        slug: "termici",
        icon: Flame,
        image: "/projects/radiant.jpg?v=2",
        it: {
            name: "Impianti Termici",
            short: "Riscaldamento radiante, caldaie e biomassa ad alta efficienza.",
            desc: "Impianti di riscaldamento tradizionali e radianti, caldaie a condensazione, impianti a biomassa e sistemi ibridi progettati per il massimo comfort e il minimo consumo energetico.",
            benefits: [
                "Riscaldamento radiante a pavimento",
                "Caldaie a condensazione e biomassa",
                "Centro assistenza Ariston, Ferroli, Haier",
                "Massimo comfort, minimi consumi",
            ],
        },
        en: {
            name: "Heating Systems",
            short: "Radiant heating, boilers and high-efficiency biomass.",
            desc: "Traditional and radiant heating systems, condensing boilers, biomass systems and hybrid solutions engineered for maximum comfort and minimum energy consumption.",
            benefits: [
                "Underfloor radiant heating",
                "Condensing and biomass boilers",
                "Ariston, Ferroli, Haier service centre",
                "Maximum comfort, minimum consumption",
            ],
        },
    },
    {
        slug: "climatizzazione",
        icon: Snowflake,
        image: "/projects/ac-outdoor.jpg?v=2",
        it: {
            name: "Climatizzazione",
            short: "Condizionamento e trattamento aria per comfort tutto l'anno.",
            desc: "Impianti di condizionamento e climatizzazione per ambienti civili e industriali, sistemi a pompa di calore, VRF e trattamento dell'aria per un comfort costante in ogni stagione.",
            benefits: [
                "Sistemi a pompa di calore e VRF",
                "Qualità dell'aria e ricambio controllato",
                "Efficienza energetica classe A",
                "Assistenza e manutenzione continua",
            ],
        },
        en: {
            name: "Air Conditioning",
            short: "Cooling and air treatment for year-round comfort.",
            desc: "Air conditioning and climate control systems for civil and industrial spaces, heat pumps, VRF systems and air treatment for constant comfort in every season.",
            benefits: [
                "Heat pump and VRF systems",
                "Air quality and controlled ventilation",
                "Class A energy efficiency",
                "Ongoing service and maintenance",
            ],
        },
    },
    {
        slug: "antincendio",
        icon: ShieldCheck,
        image: IMAGES.fire,
        it: {
            name: "Antincendio",
            short: "Estintori, reti idranti, sprinkler e sistemi certificati.",
            desc: "Progettazione e realizzazione di impianti antincendio: reti idranti, sprinkler, IRAI, porte resistenti al fuoco ed estintori, con manutenzione e certificazioni a norma di legge.",
            benefits: [
                "Reti idranti e impianti sprinkler",
                "Estintori e porte tagliafuoco",
                "Rilevazione incendi IRAI",
                "Certificazioni e manutenzioni a norma",
            ],
        },
        en: {
            name: "Fire Protection",
            short: "Extinguishers, hydrant networks, sprinklers and certified systems.",
            desc: "Design and installation of fire protection systems: hydrant networks, sprinklers, fire detection (IRAI), fire-resistant doors and extinguishers, with legally compliant maintenance and certifications.",
            benefits: [
                "Hydrant networks and sprinkler systems",
                "Extinguishers and fire doors",
                "IRAI fire detection",
                "Compliant certifications and maintenance",
            ],
        },
    },
    {
        slug: "fotovoltaico",
        icon: Sun,
        image: IMAGES.solar,
        it: {
            name: "Fotovoltaico ed Energia Solare",
            short: "Impianti fotovoltaici e solari per l'efficientamento energetico.",
            desc: "Impianti ad energia solare e fotovoltaica per la produzione di energia pulita, sistemi di accumulo e soluzioni per l'efficientamento energetico di aziende ed edifici.",
            benefits: [
                "Riduzione dei costi in bolletta",
                "Sistemi di accumulo e monitoraggio",
                "Accesso agli incentivi (Conto Termico)",
                "Energia pulita e sostenibile",
            ],
        },
        en: {
            name: "Photovoltaic & Solar",
            short: "Photovoltaic and solar systems for energy efficiency.",
            desc: "Solar and photovoltaic energy systems for clean power generation, storage systems and energy-efficiency solutions for companies and buildings.",
            benefits: [
                "Lower energy bills",
                "Storage and monitoring systems",
                "Access to incentives (Conto Termico)",
                "Clean, sustainable energy",
            ],
        },
    },
    {
        slug: "manutenzione",
        icon: Wrench,
        image: "/projects/ac-indoor.jpg?v=2",
        it: {
            name: "Manutenzione e Riparazioni",
            short: "Assistenza condominiale, industriale e privata su ogni impianto.",
            desc: "Manutenzione e riparazione di impianti condominiali, industriali e privati. Centro assistenza autorizzato con personale specializzato e interventi rapidi in tutta Italia.",
            benefits: [
                "Interventi rapidi in tutta Italia",
                "Manutenzione condominiale e industriale",
                "Centro assistenza autorizzato",
                "Contratti di assistenza programmata",
            ],
        },
        en: {
            name: "Maintenance & Repairs",
            short: "Condominium, industrial and private assistance on every system.",
            desc: "Maintenance and repair of condominium, industrial and private systems. Authorised service centre with specialised personnel and fast interventions across Italy.",
            benefits: [
                "Fast interventions across Italy",
                "Condominium and industrial maintenance",
                "Authorised service centre",
                "Scheduled service contracts",
            ],
        },
    },
];

export const PROJECT_IMG = {
    solar: "/projects/solar.jpg?v=2",
    radiant: "/projects/radiant.jpg?v=2",
    bathroom: "/projects/bathroom.jpg?v=2",
    acOutdoor: "/projects/ac-outdoor.jpg?v=2",
    acIndoor: "/projects/ac-indoor.jpg?v=2",
};

export const PROJECTS = [
    {
        id: "p1",
        category: "fotovoltaico",
        year: "2023",
        client: "Abitazione privata",
        image: PROJECT_IMG.solar,
        it: {
            name: "Impianto ad Energia Solare",
            location: "San Martino in Colle (PG)",
            desc: "Installazione di collettori solari termici su copertura in coppi per la produzione di acqua calda sanitaria di un'abitazione privata, con integrazione all'impianto esistente.",
            tech: ["Solare termico", "Produzione ACS", "Integrazione impianto"],
        },
        en: {
            name: "Solar Energy System",
            location: "San Martino in Colle (PG)",
            desc: "Installation of solar thermal collectors on a tiled roof for domestic hot water production in a private home, integrated with the existing system.",
            tech: ["Solar thermal", "Hot water", "System integration"],
        },
    },
    {
        id: "p2",
        category: "termici",
        year: "2023",
        client: "Nuova costruzione residenziale",
        image: PROJECT_IMG.radiant,
        it: {
            name: "Riscaldamento Radiante a Pavimento",
            location: "Perugia (PG)",
            desc: "Posa di impianto di riscaldamento radiante a pavimento in nuova costruzione, con pannelli isolanti bugnati e circuiti a serpentina per il massimo comfort e la minima dispersione.",
            tech: ["Riscaldamento radiante", "Pannelli bugnati", "Termoregolazione"],
        },
        en: {
            name: "Underfloor Radiant Heating",
            location: "Perugia (PG)",
            desc: "Underfloor radiant heating installation in a new build, with studded insulation panels and serpentine circuits for maximum comfort and minimal heat loss.",
            tech: ["Radiant heating", "Studded panels", "Thermal regulation"],
        },
    },
    {
        id: "p3",
        category: "idraulici",
        year: "2022",
        client: "Ristrutturazione privata",
        image: PROJECT_IMG.bathroom,
        it: {
            name: "Impianto Idraulico Bagno",
            location: "Assisi (PG)",
            desc: "Realizzazione completa dell'impianto idrico-sanitario di un bagno moderno: adduzione, scarichi, sanitari sospesi e box doccia, con finiture di pregio.",
            tech: ["Idrico-sanitario", "Sanitari sospesi", "Scarichi"],
        },
        en: {
            name: "Bathroom Plumbing System",
            location: "Assisi (PG)",
            desc: "Complete plumbing and sanitary installation for a modern bathroom: supply, drainage, wall-hung fixtures and shower enclosure, with premium finishes.",
            tech: ["Plumbing", "Wall-hung fixtures", "Drainage"],
        },
    },
    {
        id: "p4",
        category: "climatizzazione",
        year: "2023",
        client: "Struttura commerciale",
        image: PROJECT_IMG.acOutdoor,
        it: {
            name: "Climatizzazione Multi-Split Samsung",
            location: "Perugia (PG)",
            desc: "Installazione di unità esterne Samsung DVM S per la climatizzazione di una struttura commerciale, con sistema a portata di refrigerante variabile ad alta efficienza.",
            tech: ["Samsung DVM S", "VRF", "Alta efficienza"],
        },
        en: {
            name: "Samsung Multi-Split Air Conditioning",
            location: "Perugia (PG)",
            desc: "Installation of Samsung DVM S outdoor units for a commercial building, with a high-efficiency variable refrigerant flow system.",
            tech: ["Samsung DVM S", "VRF", "High efficiency"],
        },
    },
    {
        id: "p5",
        category: "climatizzazione",
        year: "2022",
        client: "Impianto industriale",
        image: PROJECT_IMG.acIndoor,
        it: {
            name: "Centrale Termofrigorifera Industriale",
            location: "Terni (TR)",
            desc: "Realizzazione della centrale tecnologica con gruppo refrigeratore, bollitore di accumulo, vaso di espansione e collettori per la climatizzazione di un edificio industriale.",
            tech: ["Gruppo refrigeratore", "Accumulo", "Collettori"],
        },
        en: {
            name: "Industrial Heating & Cooling Plant",
            location: "Terni (TR)",
            desc: "Construction of the technical plant room with chiller unit, storage tank, expansion vessel and manifolds for the climate control of an industrial building.",
            tech: ["Chiller unit", "Storage tank", "Manifolds"],
        },
    },
];

export const TESTIMONIALS = [
    {
        it: { text: "Professionalità impeccabile dalla progettazione alla consegna. Un partner affidabile.", author: "Studio Tecnico Rossi", role: "Cliente industriale" },
        en: { text: "Impeccable professionalism from design to delivery. A reliable partner.", author: "Studio Tecnico Rossi", role: "Industrial client" },
    },
    {
        it: { text: "Lavoro consegnato nei tempi previsti e con la massima cura dei dettagli.", author: "Amministrazione Condominio Sole", role: "Amministratore" },
        en: { text: "Work delivered on schedule with the utmost attention to detail.", author: "Condominio Sole", role: "Property manager" },
    },
    {
        it: { text: "Squadra qualificata e disponibile. Impianto fotovoltaico perfetto, consumi abbattuti.", author: "Azienda Agricola Umbra", role: "Titolare" },
        en: { text: "Qualified and helpful team. Perfect PV system, drastically reduced costs.", author: "Umbrian Farm", role: "Owner" },
    },
];

export const CLIENTS = ["ARISTON", "FERROLI", "HAIER", "COMUNE DI PERUGIA", "LOGISTICA UMBRA", "HOTEL ASSISI", "STUDIO ROSSI"];

// Real partner / service-centre brands Gruppo CB works with. Logos via Clearbit logo API.
export const PARTNER_BRANDS = [
    { name: "Ariston", domain: "ariston.com" },
    { name: "Ferroli", domain: "ferroli.com" },
    { name: "Haier", domain: "haier.com" },
    { name: "Daikin", domain: "daikin.com" },
    { name: "Vaillant", domain: "vaillant.com" },
    { name: "Bosch", domain: "bosch.com" },
    { name: "Viessmann", domain: "viessmann.com" },
    { name: "Immergas", domain: "immergas.com" },
];

export const ADVANTAGES_KEYS = [
    "certified",
    "quality",
    "innovation",
    "compliance",
    "onTime",
    "aftersales",
];


export const CERTIFICATIONS = [
    { key: "soa", img: "/certs/soa.png" },
    { key: "rina", img: "/certs/rina.png" },
    { key: "fgas", img: "/certs/fgas.png" },
    { key: "albo", img: "/certs/albo.png" },
    { key: "raee", img: "/certs/raee.png" },
    { key: "itec", img: "/certs/itec.png" },
    { key: "kiwa", img: "/certs/kiwa.png" },
];

export const TEAM_PHOTO = "/team/squadra.jpg?v=2";

export const OFFICES = [
    "/uffici/ufficio-1.jpg",
    "/uffici/ufficio-2.jpg",
    "/uffici/ufficio-3.jpg",
];

// Interactive coverage map — seed data (expandable). Coordinates [lng, lat].
export const ZONES = [
    {
        id: "genova",
        lat: 44.4056, lng: 8.9463,
        it: { name: "Genova", region: "Liguria" },
        en: { name: "Genoa", region: "Liguria" },
        works: [
            {
                year: "2024–2026", cats: ["idraulici", "termici", "climatizzazione"],
                it: "Fornitura e posa in opera di maxi-impianti meccanici, idrotermosanitari e di condizionamento nell'ambito dei Piani Urbani Integrati finanziati dal PNRR per la Città Metropolitana.",
                en: "Supply and installation of large-scale mechanical, plumbing and air-conditioning systems within the PNRR-funded Integrated Urban Plans for the Metropolitan City.",
            },
        ],
    },
    {
        id: "bologna",
        lat: 44.4949, lng: 11.3426,
        it: { name: "Bologna", region: "Emilia-Romagna" },
        en: { name: "Bologna", region: "Emilia-Romagna" },
        works: [
            {
                year: "2025–2026", cats: ["manutenzione", "termici"],
                it: "Servizi di manutenzione straordinaria ed efficientamento energetico su centrali termiche e impianti termoidraulici per strutture direzionali e istituzionali.",
                en: "Extraordinary maintenance and energy-efficiency services on thermal plants and hydronic systems for corporate and institutional buildings.",
            },
        ],
    },
    {
        id: "arezzo",
        lat: 43.4633, lng: 11.8796,
        it: { name: "Arezzo", region: "Toscana" },
        en: { name: "Arezzo", region: "Tuscany" },
        works: [
            {
                year: "2023–2024", cats: ["climatizzazione", "termici"],
                it: "Progettazione e installazione di sistemi integrati di riscaldamento e climatizzazione per il settore residenziale e per complessi condominiali.",
                en: "Design and installation of integrated heating and air-conditioning systems for the residential sector and condominium complexes.",
            },
        ],
    },
    {
        id: "umbria",
        lat: 43.0489, lng: 12.3542,
        it: { name: "Umbria", region: "Sede · Perugia" },
        en: { name: "Umbria", region: "HQ · Perugia" },
        works: [
            { year: "2023", cats: ["fotovoltaico"], it: "Impianto ad energia solare, San Martino in Colle.", en: "Solar energy system, San Martino in Colle." },
            { year: "2023", cats: ["termici", "climatizzazione"], it: "Riscaldamento radiante e climatizzazione multi-split, Perugia.", en: "Radiant heating and multi-split air conditioning, Perugia." },
            { year: "2022", cats: ["idraulici"], it: "Impianto idraulico struttura ricettiva, Assisi.", en: "Plumbing system for hospitality facility, Assisi." },
        ],
    },
    {
        id: "marche",
        lat: 43.4, lng: 13.3,
        it: { name: "Marche", region: "Marche" },
        en: { name: "Marche", region: "Marche" },
        works: [
            {
                year: "2022–2024", cats: ["antincendio", "idraulici"],
                it: "Adeguamento normativo, posa di impianti idrici antincendio e rifacimento reti di scarico/adduzione per edifici civili e commerciali.",
                en: "Regulatory upgrades, installation of fire-fighting water systems and renovation of drainage/supply networks for civil and commercial buildings.",
            },
        ],
    },
    {
        id: "abruzzo",
        lat: 42.2, lng: 13.85,
        it: { name: "Abruzzo", region: "Abruzzo" },
        en: { name: "Abruzzo", region: "Abruzzo" },
        works: [
            {
                year: "2023–2025", cats: ["fotovoltaico", "manutenzione"],
                it: "Installazione di impianti solari fotovoltaici per l'efficientamento di strutture pubbliche e manutenzione ordinaria degli impianti tecnologici di presidi territoriali.",
                en: "Installation of solar photovoltaic systems for public facilities and routine maintenance of technological systems in local facilities.",
            },
        ],
    },
    {
        id: "calabria",
        lat: 38.9098, lng: 16.5877,
        it: { name: "Calabria", region: "Calabria" },
        en: { name: "Calabria", region: "Calabria" },
        works: [
            {
                year: "2024–2025", cats: ["climatizzazione", "idraulici"],
                it: "Interventi di ristrutturazione impiantistica e installazione di moderni sistemi di condizionamento e trattamento aria (UTA) per strutture ricettive e commerciali.",
                en: "Plant refurbishment and installation of modern air-conditioning and air-handling (AHU) systems for hospitality and commercial facilities.",
            },
        ],
    },
    {
        id: "sicilia",
        lat: 38.1157, lng: 13.3615,
        it: { name: "Sicilia", region: "Sicilia" },
        en: { name: "Sicily", region: "Sicily" },
        works: [
            {
                year: "2024–2025", cats: ["climatizzazione", "idraulici"],
                it: "Interventi di ristrutturazione impiantistica e installazione di moderni sistemi di condizionamento e trattamento aria (UTA) per strutture ricettive e commerciali.",
                en: "Plant refurbishment and installation of modern air-conditioning and air-handling (AHU) systems for hospitality and commercial facilities.",
            },
        ],
    },

    // Liguria
    { id: "savona", lat: 44.3075, lng: 8.4816, it: { name: "Savona", region: "Liguria" }, en: { name: "Savona", region: "Liguria" }, works: [{ year: "2023–2024", cats: ["termici", "idraulici"], it: "Efficientamento energetico e opere idrauliche per edifici residenziali.", en: "Energy efficiency and plumbing works for residential buildings." }] },
    { id: "la-spezia", lat: 44.1025, lng: 9.8241, it: { name: "La Spezia", region: "Liguria" }, en: { name: "La Spezia", region: "Liguria" }, works: [{ year: "2024–2025", cats: ["idraulici", "termici"], it: "Riqualificazione energetica e rifacimento impianti idrotermosanitari.", en: "Energy retrofit and renovation of plumbing systems." }] },
    { id: "imperia", lat: 43.8869, lng: 8.0276, it: { name: "Imperia", region: "Liguria" }, en: { name: "Imperia", region: "Liguria" }, works: [{ year: "2022–2023", cats: ["fotovoltaico", "idraulici"], it: "Efficientamento energetico con fotovoltaico e opere idrauliche.", en: "Energy efficiency with photovoltaics and plumbing works." }] },

    // Toscana
    { id: "firenze", lat: 43.7696, lng: 11.2558, it: { name: "Firenze", region: "Toscana" }, en: { name: "Florence", region: "Tuscany" }, works: [{ year: "2023–2025", cats: ["termici", "idraulici"], it: "Efficientamento energetico e opere idrauliche per edifici residenziali e direzionali.", en: "Energy efficiency and plumbing works for residential and office buildings." }] },
    { id: "siena", lat: 43.3188, lng: 11.3308, it: { name: "Siena", region: "Toscana" }, en: { name: "Siena", region: "Tuscany" }, works: [{ year: "2022–2024", cats: ["idraulici", "termici"], it: "Riqualificazione energetica e rifacimento impianti idrotermosanitari.", en: "Energy retrofit and renovation of plumbing systems." }] },
    { id: "pisa", lat: 43.7161, lng: 10.3966, it: { name: "Pisa", region: "Toscana" }, en: { name: "Pisa", region: "Tuscany" }, works: [{ year: "2024–2026", cats: ["climatizzazione", "idraulici"], it: "Installazione di impianti ad alta efficienza e reti idriche per strutture commerciali.", en: "High-efficiency systems and water networks for commercial facilities." }] },
    { id: "livorno", lat: 43.5485, lng: 10.3106, it: { name: "Livorno", region: "Toscana" }, en: { name: "Livorno", region: "Tuscany" }, works: [{ year: "2023–2024", cats: ["fotovoltaico", "idraulici"], it: "Efficientamento energetico con fotovoltaico e opere idrauliche.", en: "Energy efficiency with photovoltaics and plumbing works." }] },

    // Emilia-Romagna
    { id: "modena", lat: 44.6471, lng: 10.9252, it: { name: "Modena", region: "Emilia-Romagna" }, en: { name: "Modena", region: "Emilia-Romagna" }, works: [{ year: "2024–2026", cats: ["termici", "idraulici"], it: "Efficientamento energetico e opere idrauliche per edifici industriali.", en: "Energy efficiency and plumbing works for industrial buildings." }] },
    { id: "parma", lat: 44.8015, lng: 10.3279, it: { name: "Parma", region: "Emilia-Romagna" }, en: { name: "Parma", region: "Emilia-Romagna" }, works: [{ year: "2023–2025", cats: ["idraulici", "termici"], it: "Riqualificazione energetica e rifacimento impianti idrotermosanitari.", en: "Energy retrofit and renovation of plumbing systems." }] },
    { id: "rimini", lat: 44.0678, lng: 12.5695, it: { name: "Rimini", region: "Emilia-Romagna" }, en: { name: "Rimini", region: "Emilia-Romagna" }, works: [{ year: "2024–2025", cats: ["climatizzazione", "idraulici"], it: "Impianti ad alta efficienza e reti idriche per strutture ricettive.", en: "High-efficiency systems and water networks for hospitality facilities." }] },
    { id: "ferrara", lat: 44.8381, lng: 11.6198, it: { name: "Ferrara", region: "Emilia-Romagna" }, en: { name: "Ferrara", region: "Emilia-Romagna" }, works: [{ year: "2022–2024", cats: ["fotovoltaico", "idraulici"], it: "Efficientamento energetico con fotovoltaico e opere idrauliche.", en: "Energy efficiency with photovoltaics and plumbing works." }] },

    // Lazio
    { id: "roma", lat: 41.9028, lng: 12.4964, it: { name: "Roma", region: "Lazio" }, en: { name: "Rome", region: "Lazio" }, works: [{ year: "2024–2026", cats: ["termici", "idraulici"], it: "Efficientamento energetico e opere idrauliche per edifici residenziali e istituzionali.", en: "Energy efficiency and plumbing works for residential and institutional buildings." }] },
    { id: "latina", lat: 41.4677, lng: 12.9037, it: { name: "Latina", region: "Lazio" }, en: { name: "Latina", region: "Lazio" }, works: [{ year: "2023–2025", cats: ["idraulici", "termici"], it: "Riqualificazione energetica e rifacimento impianti idrotermosanitari.", en: "Energy retrofit and renovation of plumbing systems." }] },
    { id: "viterbo", lat: 42.4207, lng: 12.1077, it: { name: "Viterbo", region: "Lazio" }, en: { name: "Viterbo", region: "Lazio" }, works: [{ year: "2022–2024", cats: ["fotovoltaico", "idraulici"], it: "Efficientamento energetico con fotovoltaico e opere idrauliche.", en: "Energy efficiency with photovoltaics and plumbing works." }] },
    { id: "frosinone", lat: 41.6402, lng: 13.3517, it: { name: "Frosinone", region: "Lazio" }, en: { name: "Frosinone", region: "Lazio" }, works: [{ year: "2023–2024", cats: ["climatizzazione", "idraulici"], it: "Impianti ad alta efficienza e reti idriche per strutture commerciali.", en: "High-efficiency systems and water networks for commercial facilities." }] },

    // Marche
    { id: "ancona", lat: 43.6158, lng: 13.5189, it: { name: "Ancona", region: "Marche" }, en: { name: "Ancona", region: "Marche" }, works: [{ year: "2023–2025", cats: ["termici", "idraulici"], it: "Efficientamento energetico e opere idrauliche per edifici civili e commerciali.", en: "Energy efficiency and plumbing works for civil and commercial buildings." }] },
    { id: "pesaro", lat: 43.9102, lng: 12.9132, it: { name: "Pesaro", region: "Marche" }, en: { name: "Pesaro", region: "Marche" }, works: [{ year: "2022–2024", cats: ["idraulici", "termici"], it: "Riqualificazione energetica e rifacimento impianti idrotermosanitari.", en: "Energy retrofit and renovation of plumbing systems." }] },
    { id: "macerata", lat: 43.3007, lng: 13.4536, it: { name: "Macerata", region: "Marche" }, en: { name: "Macerata", region: "Marche" }, works: [{ year: "2024–2025", cats: ["fotovoltaico", "idraulici"], it: "Efficientamento energetico con fotovoltaico e opere idrauliche.", en: "Energy efficiency with photovoltaics and plumbing works." }] },

    // Abruzzo
    { id: "pescara", lat: 42.4643, lng: 14.2142, it: { name: "Pescara", region: "Abruzzo" }, en: { name: "Pescara", region: "Abruzzo" }, works: [{ year: "2023–2025", cats: ["termici", "idraulici"], it: "Efficientamento energetico e opere idrauliche per edifici residenziali.", en: "Energy efficiency and plumbing works for residential buildings." }] },
    { id: "chieti", lat: 42.3512, lng: 14.1678, it: { name: "Chieti", region: "Abruzzo" }, en: { name: "Chieti", region: "Abruzzo" }, works: [{ year: "2022–2024", cats: ["idraulici", "termici"], it: "Riqualificazione energetica e rifacimento impianti idrotermosanitari.", en: "Energy retrofit and renovation of plumbing systems." }] },
    { id: "teramo", lat: 42.6589, lng: 13.7042, it: { name: "Teramo", region: "Abruzzo" }, en: { name: "Teramo", region: "Abruzzo" }, works: [{ year: "2024–2026", cats: ["climatizzazione", "idraulici"], it: "Impianti ad alta efficienza e reti idriche per presidi territoriali.", en: "High-efficiency systems and water networks for local facilities." }] },
];
